function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { browserTracingIntegration as browserTracingIntegration$1, startBrowserTracingNavigationSpan } from '@sentry/browser';
import { instrumentVueRouter } from './router.js'; // The following type is an intersection of the Route type from VueRouter v2, v3, and v4.
// This is not great, but kinda necessary to make it work with all versions at the same time.

/**
 * A custom browser tracing integrations for Vue.
 */

function browserTracingIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // If router is not passed, we just use the normal implementation
  if (!options.router) {
    return browserTracingIntegration$1(options);
  }

  var integration = browserTracingIntegration$1(_objectSpread(_objectSpread({}, options), {}, {
    instrumentNavigation: false
  }));
  var router = options.router,
      _options$instrumentNa = options.instrumentNavigation,
      instrumentNavigation = _options$instrumentNa === void 0 ? true : _options$instrumentNa,
      _options$instrumentPa = options.instrumentPageLoad,
      instrumentPageLoad = _options$instrumentPa === void 0 ? true : _options$instrumentPa,
      _options$routeLabel = options.routeLabel,
      routeLabel = _options$routeLabel === void 0 ? 'name' : _options$routeLabel;
  return _objectSpread(_objectSpread({}, integration), {}, {
    afterAllSetup: function afterAllSetup(client) {
      integration.afterAllSetup(client);

      var startNavigationSpan = function startNavigationSpan(options) {
        startBrowserTracingNavigationSpan(client, options);
      };

      instrumentVueRouter(router, {
        routeLabel: routeLabel,
        instrumentNavigation: instrumentNavigation,
        instrumentPageLoad: instrumentPageLoad
      }, startNavigationSpan);
    }
  });
}

export { browserTracingIntegration };